/* eslint-disable react/prop-types */
/* eslint-disable no-underscore-dangle */
// import 'core-js/stable';
import 'core-js/es7';
import { Route, Routes } from 'react-router-dom';
import { Provider } from 'react-redux';
import React from 'react';
import ReactDOM from 'react-dom';
import styled from 'styled-components';
import './utils/setupLocalization';
import config from './config';
import AppInner from './App/index';
import ErrorBoundary from './ErrorBoundary';
import { getStore } from './store';
import ThdThemeProvider from './theme/ThdThemeProvider';

export const Render = () => {
  // Only run on client side
  if (typeof window !== 'undefined') {
    window.__MARKETPLACE__ = { settings: config() };
    window.React = React;
    window.ReactDOM = ReactDOM;
    window.StyledComponents = styled;
  }

  return (
    <div className="container-fluid">
      <ErrorBoundary>
        <Provider store={getStore()}>
          <ThdThemeProvider>
            <Routes>
              <Route path="/" element={<AppInner />} />
            </Routes>
          </ThdThemeProvider>
        </Provider>
      </ErrorBoundary>
    </div>
  );

};
